export const OnboardingRoutes = {
  tours: {
    list: () => '/tours?platform=mobile_client',
  },
  users: {
    recordTour: () => '/me/onboarding-tours',
  },
};
